export default __webpack_public_path__ + "static/media/cerebraniumLogo.47280df0.png";